import React from "react";

const BackButton = ({ onBackClick = () => {}, Icon }) => {
  const handleBackClick = () => {
    if (onBackClick) {
      onBackClick();
    }
  };

  return (
    <>
      <div className="back-btn-wrapper" onClick={handleBackClick}>
        <span className="back-btn">{!!Icon && Icon}</span>
      </div>
    </>
  );
};

export default BackButton;
